var _defs, _circle, _text;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGeoFresno(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#b6b6b7;}.cls-2{font-size:4.85px;fill:#221f1f;font-family:Helvetica-Bold, Helvetica;font-weight:700;letter-spacing:0.02em;}.cls-3{letter-spacing:-0.04em;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 7.5,
    cy: 7.5,
    r: 5.6
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(3.7 9.1)"
  }, "F", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 3.6,
    y: 0
  }, "r."))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeoFresno);
export default __webpack_public_path__ + "static/media/geo_fresno.85d4bed7782ff776e7cc3a8429c47872.svg";
export { ForwardRef as ReactComponent };